const parseAnchorNames = (anchorNames: string): string[] =>
  anchorNames
    .split(',')
    .map(anchorName => anchorName.trim())
    .filter(anchorName => anchorName !== '' && anchorName !== 'none');

export const addAnchorName = (
  anchorNames: string,
  anchorName: string
): string =>
  [
    ...parseAnchorNames(anchorNames).filter(name => name !== anchorName),
    anchorName,
  ].join(', ');

export const removeAnchorName = (
  anchorNames: string,
  anchorName: string
): string =>
  parseAnchorNames(anchorNames)
    .filter(name => name !== anchorName)
    .join(', ');
